
import common from './pt/common';
import home from './pt/home';
import airports from './pt/airports';
import profiles from './pt/profiles';
import settings from './pt/settings';
import reviews from './pt/reviews';
import inventory from './pt/inventory';
import auth from './pt/auth';
import navigation from './pt/navigation';

// Merge all translation categories into one object
const translations = {
  ...common,
  ...home,
  ...airports,
  ...profiles,
  ...settings,
  ...reviews,
  ...inventory,
  ...auth,
  ...navigation,
};

export default translations;
